import { useCallback } from 'react';

import { useFloorplanDesignStore } from '@/modules/floorplanDesign/store/useFloorplanDesignStore';
import { isHighwayArea } from '@/modules/floorplanDesign/helpers';
import { useAppStore } from '@/modules/app/store/useAppStore';

import { HIGHWAY_ARROW_ID } from '../constants/elements';
import { CanvasServiceFactory } from '../services/Canvas/CanvasServiceFactory';
import { useCanvasStore } from '../store';
import { HideElementsService } from '@/modules/canvas';

export const useEditStart = () => {
  const { getAreaById } = useFloorplanDesignStore();
  const selectedIds = useAppStore((state) => state.selectedIds);
  const canvasSvc = CanvasServiceFactory.getInstance().createCanvasService();

  const editStarted = useCallback(() => {
    if (selectedIds.length !== 1) {
      return;
    }

    const area = getAreaById(selectedIds[0]);
    if (area === undefined || !isHighwayArea(area)) {
      return;
    }

    const canvas = useCanvasStore.getState().instance;
    if (!canvas) return;
    const element = canvas.getElement(area.id);
    if (!element) return;

    if (element.type !== 'AngledHighway' && element.type !== 'LinePath') {
      return;
    }

    const componentIds: string[] = area.segments.map((e) => `${e.id}-${HIGHWAY_ARROW_ID}`);

    // update canvas
    HideElementsService.instance.hideFloorplanElements([element.id]);
    canvasSvc.removeCanvasElements({ method: 'byId', ids: componentIds });
  }, [selectedIds, getAreaById, canvasSvc]);

  return { editStarted };
};
